// Relógio da tela (corrigido pela hora do servidor) e aviso sonoro ao fim da estimativa.
import { useEffect, useRef, useState } from 'react';
import { crossedEstimate, elapsedSeconds } from '../domain/timer';
import type { SoundPlayer } from '../platform/sound';
import { useAppState, useStore } from './AppStore';

export function useNow(intervalMs = 1000): number {
  const store = useStore();
  const [now, setNow] = useState(() => store.now());
  useEffect(() => {
    setNow(store.now());
    const id = setInterval(() => setNow(store.now()), intervalMs);
    return () => clearInterval(id);
  }, [store, intervalMs]);
  return now;
}

/** Toca o aviso UMA vez quando a tarefa rodando chega a zero (AC-022). */
export function useEstimateAlarm(sound: SoundPlayer): void {
  const now = useNow();
  const running = useAppState((s) => s.tasks.find((t) => t.status === 'running') ?? null);
  const last = useRef<{ id: string; elapsed: number } | null>(null);
  useEffect(() => {
    if (!running) {
      last.current = null;
      return;
    }
    const elapsed = elapsedSeconds(running, now);
    const prev = last.current?.id === running.id ? last.current.elapsed : elapsed;
    if (crossedEstimate(running, prev, elapsed)) sound.play('estimate');
    last.current = { id: running.id, elapsed };
  }, [now, running, sound]);
}
